import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import ArticleMeta from "./article-meta"

export default ({ article }) => (
  <div className="main-article" key={article.link}>
    <ArticleMeta article={article} />
    <div className="article-content">
      <AniLink fade to={article.link}>
        <img
          src={article.image}
          className="attachment-wide-thumbnail size-wide-thumbnail wp-post-image"
          alt={article.title}
        />
      </AniLink>
      <p>{article.excerpt}</p>
      <div className="article-more">
        <AniLink fade to={article.link}>
          read more ...
        </AniLink>
      </div>
    </div>
  </div>
)
